import React, { Fragment, useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  Body,
  Caption1,
  Title1,
  Title3,
  Callout,
} from '../../../../components/Typography';
import Select from '../../../../components/Select';
import formatAddressName from '../../../../utils/formatAddressName';
import UnavailableMessage from '../../OrderSettingModal/components/UnavailableDeliveryMessage';
import SkeletonLoading from '../../OrderSettingModal/components/SkeletonLoading';
import LocationCard from './LocationCard';
import LocationCustomFormatLabel from '../../OrderSettingModal/components/LocationCustomLabel';
import { PICKUP, DELIVERY, DROPOFF } from '../../orderSettingTypes';
import GuestDeliveryAddressForm from '../../OrderSettingModal/components/GuestDeliveryAddressForm';
import appConfigFile from '../../../../../app-config';
import { navigate } from 'gatsby';

const MainDiv = styled.div`
  background: white;
  padding: 19px 36px 32px 36px;
  margin: 0;
  border-bottom: solid 3px #ebebeb;
  margin-top: 5px;
  border-start-start-radius: 5px;

  @media (max-width: 786px) {
    padding: 16px;
    align-items: center;
  }

  @media (min-width: 800px) {
    min-width: 750px;
  }

  @media (min-width: 1080px) {
    min-width: 960px;
  }
`;
const LocationsWrapper = styled.div`
  display: grid;
  overflow-y: auto;
  max-height: 450px;
  padding: 19px 36px 0 36px;
  margin-bottom: 5px;
  border-end-end-radius: 5px;
  @media (max-width: 786px) {
    padding: 16px 16px 32px 16px;
    align-items: center;
    width: 100%;
  }
`;
const SectionWrapper = styled.div`
  display: grid;
  grid-template-columns: 2fr 2fr 2fr;
  width: 100%;
  @media (max-width: 786px) {
    display: block;
  }
`;
const Title = styled(Title1)`
  font-weight: 600;
  margin-bottom: 10px;
  margin-top: 5px;
`;
const SelectSectionWrapper = styled.div`
  margin: 0 16px 0 0;
  @media (max-width: 786px) {
    display: block;
    margin: 9px 0;
  }
`;
const StoresWrapper = styled.div`
  display: grid;
`;
const AddNewAddressButton = styled(Caption1)`
  margin: 10px 0 0 0;
  cursor: pointer;
  color: ${(props) => props.color || props.theme.clickableTextColor};
  &:hover {
    color: ${(props) => props.theme.clickableTextColorHover};
  }
`;

const SelectTitleWrapper = styled.div`
  display: block;
  align-items: center;
  align-content: center;

  @media (min-width: 786px) {
    padding-top: 10px;
  }
`;

const Stores = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0px 46px;
  padding: 0 5px;
  animation: fadeIn 0.5s ease-in-out;

  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const CalloutWrapper = styled(Callout)`
  display: flex;
  &:hover {
    color: ${(props) => props.theme.clickableTextColorHover};
  }
`;

const GuestDeliveryForm = styled.div`
  margin-top: 20px;
`;

const MarketplaceDelivery = ({
  deliveryAddressesList,
  interDeliveryDetails,
  interOrderType,
  resetInterSelectedDateTime,
  isRequesting,
  confirmMarketplaceDeliverySelection,
  setDeliveryAddressesFormIsVisible,
  resetIsTimeNoLongerValid,
  isAuthenticated,
  orderSettingModalIsVisible,
  deepLinkParameters,
  updateInterOrderType,
  getMarketplaceDeliveryLocations,
  marketplaceDeliveryLocations,
  locations,
  isMarketplaceDeliveryLocationsRequest,
  setDeliveryTimeFormIsVisible,
  deliveryDetails,
  isUnavailableProductInCartRequest,
  checkUnavailableProductForMarketplace,
  resetMarketplaceDeliveryLocations,
  confirmDeliveryDetails,
  getTimeIntervalsDate,
  deliveryToAddress,
  updateInterDeliveryDetails,
  setMarketplaceDeliverySelection,
  parentLocation,
  setParentLocation,
  getChildLocations,
  appConfig,
  guestDeliveryFormInitialAddress,
  setGuestDeliveryAddressFormInitialValues,
  updateOrderSettingModalIsVisible,
  profileSettingsReducer,
  validateCartForLocation,
  isDeepLink,
  isParentDeepLink,
  setIsParentStoreDeepLink,
  childLocations,
  validateGlobalCart,
}) => {
  const [deliveryLocation, setDeliveryLocation] = useState(null);

  const { appSource } = appConfigFile;
  const { email } = profileSettingsReducer;

  let filteredMarketplaceDeliveryLocations = [];

  // if (deliveryDetails) {
  //   filteredMarketplaceDeliveryLocations = marketplaceDeliveryLocations.filter(
  //     (location) => location.business_id !== deliveryDetails.business_id
  //   );
  // } else {
  filteredMarketplaceDeliveryLocations = marketplaceDeliveryLocations;

  const filteredLocations = locations.length
    ? locations.filter(
        (location) => location.accepted_order_types[0] !== 'scan_and_go'
      )
    : [];

  useEffect(() => {
    if (deepLinkParameters?.parentId && locations && locations.length > 0) {
      const parentStore = locations.filter(
        (addr) => addr.id === parseInt(deepLinkParameters.parentId)
      );
      if (parentStore.length > 0 && !isParentDeepLink) {
        setParentLocation(parentStore[0]);
        setIsParentStoreDeepLink(true);
      }
    }
  }, [locations]);

  // useEffect(() => {
  //   if (deliveryToAddress) {
  //     const address = deliveryAddressesList.filter(
  //       (addr) => addr.line1 === deliveryToAddress.line1
  //     );
  //     if (address.length > 0) {
  //       setDeliveryLocation(address[0]);
  //       updateInterDeliveryDetails(address[0]);
  //     }
  //   }
  // }, [deliveryToAddress, deliveryAddressesList]);

  useEffect(() => {
    if (parentLocation && interOrderType) {
      getChildLocations(parentLocation.id);

      const strParentLocation = JSON.stringify(parentLocation);

      if (isAuthenticated && !appConfigFile.isDeepLinkClient) {
        localStorage.setItem(`${appSource}-${email}`, strParentLocation);
      } else {
        localStorage.setItem(`${appSource}-guest`, strParentLocation);
      }
    }
  }, [parentLocation, interOrderType]);
  // useEffect(() => {
  //   if (deliveryLocation && childLocations)
  //     getMarketplaceDeliveryLocations(deliveryLocation);
  // }, [deliveryLocation, childLocations]);
  useEffect(() => {
    const cachedParentLocation = isAuthenticated
      ? localStorage.getItem(`${appSource}-${email}`)
      : localStorage.getItem(`${appSource}-guest`);

    if (cachedParentLocation && !appConfigFile.isDeepLinkClient) {
      const parsedLocation = JSON.parse(cachedParentLocation);
      setParentLocation(parsedLocation);
    }
  }, []);

  const onOrderTypeChange = (interOrderType) => {
    if (interOrderType === PICKUP) {
      updateInterOrderType(interOrderType);
    } else if (interOrderType === DELIVERY) {
      updateInterOrderType(interOrderType);
    } else if (interOrderType === DROPOFF) {
      updateInterOrderType(interOrderType);
    }
  };
  const isCurrentStore = (store) => {
    if (
      interDeliveryDetails &&
      interDeliveryDetails.deliveryBusiness &&
      store &&
      store.deliveryBusiness
    ) {
      if (
        interDeliveryDetails.deliveryBusiness.id === store.deliveryBusiness.id
      ) {
        return true;
      }
    }

    return false;
  };
  const availableOrderMethods = parentLocation
    ? parentLocation.accepted_order_types
    : [];
  return (
    <>
      <MainDiv>
        {appConfigFile.isMarketplaceDelivery ? (
          <SelectSectionWrapper>
            {deliveryAddressesList?.length > 0 && (
              <Select
                value={
                  deliveryLocation ? deliveryLocation : interDeliveryDetails
                }
                options={deliveryAddressesList}
                getOptionLabel={(deliveryAddress) =>
                  formatAddressName(deliveryAddress)
                }
                getOptionValue={(deliveryAddress) => deliveryAddress}
                onChange={(deliveryAddress) => {
                  resetInterSelectedDateTime();
                  resetIsTimeNoLongerValid();
                  resetMarketplaceDeliveryLocations();
                  setDeliveryLocation(deliveryAddress);
                  getMarketplaceDeliveryLocations(deliveryAddress);
                }}
                isDisabled={isRequesting}
                interOrderType={interOrderType}
                triggerOnChange
              />
            )}
            <AddNewAddressButton
              onClick={() => setDeliveryAddressesFormIsVisible(true)}
            >
              <CalloutWrapper>+ Add New address</CalloutWrapper>
            </AddNewAddressButton>

            {isMarketplaceDeliveryLocationsRequest ? (
              <div />
            ) : (
              <Fragment>
                {!isMarketplaceDeliveryLocationsRequest &&
                marketplaceDeliveryLocations.length === 0 &&
                parentLocation &&
                deliveryLocation &&
                appSource != 'thebottledrive' ? (
                  <UnavailableMessage
                    marginTop="-55px"
                    title={
                      'We are unable to deliver to this address at this time. Select Pickup above to pickup instead.'
                    }
                  />
                ) : null}
                {!isMarketplaceDeliveryLocationsRequest &&
                marketplaceDeliveryLocations.length === 0 &&
                parentLocation &&
                deliveryLocation &&
                appSource == 'thebottledrive' ? (
                  <UnavailableMessage
                    marginTop="-55px"
                    title={
                      'We are unable to delivery to this address at this time.'
                    }
                  />
                ) : null}
              </Fragment>
            )}
          </SelectSectionWrapper>
        ) : (
          <>
            <Title>{'Order Method'}</Title>
            <SectionWrapper>
              <SelectSectionWrapper>
                <Select
                  value={parentLocation}
                  options={filteredLocations}
                  getOptionLabel={(location) => location.name}
                  getOptionValue={(location) => location}
                  placeholder="Select a Location ..."
                  maxMenuHeight={200}
                  isLocation={true}
                  onChange={(location) => setParentLocation(location)}
                  isDisabled={isParentDeepLink}
                  formatOptionLabel={(location) => (
                    <LocationCustomFormatLabel
                      location={location}
                      interPickUpDetails={interDeliveryDetails}
                    />
                  )}
                />
                {appConfigFile.appSource !== 'feastify' ? (
                  <AddNewAddressButton
                    to="/locations"
                    onClick={() => {
                      navigate('/locations');
                      updateOrderSettingModalIsVisible(false);
                    }}
                  >
                    <CalloutWrapper
                      style={{ marginTop: '5px', marginLeft: '5px' }}
                    >
                      View Map
                    </CalloutWrapper>
                  </AddNewAddressButton>
                ) : null}
              </SelectSectionWrapper>
              <SelectSectionWrapper>
                <Select
                  options={availableOrderMethods.map((value) => ({
                    value: value,
                    name: value.charAt(0).toUpperCase() + value.slice(1),
                  }))}
                  placeholder="Select Order Type"
                  getOptionLabel={(option) =>
                    option.name ? option.name.replaceAll('_', '-') : null
                  }
                  getOptionValue={(option) =>
                    option.value ? option.value : null
                  }
                  onChange={(interOrderType) =>
                    onOrderTypeChange(interOrderType)
                  }
                  isDisabled={
                    appConfigFile && appConfigFile.appSource == 'thebottledrive'
                      ? true
                      : false
                  }
                  value={
                    interOrderType
                      ? {
                          value: interOrderType,
                          name:
                            interOrderType.charAt(0).toUpperCase() +
                            interOrderType.slice(1),
                        }
                      : null
                  }
                />
              </SelectSectionWrapper>
              <SelectSectionWrapper>
                {isAuthenticated && (
                  <>
                    <Select
                      value={
                        deliveryLocation
                          ? deliveryLocation
                          : interDeliveryDetails
                      }
                      options={deliveryAddressesList}
                      getOptionLabel={(deliveryAddress) =>
                        formatAddressName(deliveryAddress)
                      }
                      getOptionValue={(deliveryAddress) => deliveryAddress}
                      onChange={(deliveryAddress) => {
                        resetInterSelectedDateTime();
                        resetIsTimeNoLongerValid();
                        resetMarketplaceDeliveryLocations();

                        setDeliveryLocation(deliveryAddress);
                        getMarketplaceDeliveryLocations(deliveryAddress);
                      }}
                      isDisabled={isRequesting}
                      interOrderType={interOrderType}
                      triggerOnChange
                    />
                    <AddNewAddressButton
                      onClick={() => setDeliveryAddressesFormIsVisible(true)}
                    >
                      <CalloutWrapper>+ Add New address</CalloutWrapper>
                    </AddNewAddressButton>
                  </>
                )}
                {isMarketplaceDeliveryLocationsRequest ? (
                  <div />
                ) : (
                  <Fragment>
                    {!isMarketplaceDeliveryLocationsRequest &&
                    marketplaceDeliveryLocations.length === 0 &&
                    parentLocation &&
                    deliveryLocation &&
                    appSource != 'thebottledrive' ? (
                      <UnavailableMessage
                        marginTop="-55px"
                        title={
                          'We are unable to deliver to this address at this time. Select Pickup above to pickup instead.'
                        }
                      />
                    ) : null}
                    {!isMarketplaceDeliveryLocationsRequest &&
                    marketplaceDeliveryLocations.length === 0 &&
                    parentLocation &&
                    deliveryLocation &&
                    appSource == 'thebottledrive' ? (
                      <UnavailableMessage
                        marginTop="-55px"
                        title={
                          'We are unable to delivery to this address at this time.'
                        }
                      />
                    ) : null}
                  </Fragment>
                )}
              </SelectSectionWrapper>
            </SectionWrapper>
            {appConfig && appConfig.guest_checkout_enabled && !isAuthenticated && (
              <GuestDeliveryForm>
                <Body style={{ fontWeight: 'bold', marginLeft: '10px' }}>
                  Delivery to:
                </Body>
                <GuestDeliveryAddressForm
                  guestDeliveryFormInitialAddress={
                    guestDeliveryFormInitialAddress
                  }
                  updateInterDeliveryDetails={updateInterDeliveryDetails}
                  setGuestDeliveryAddressFormInitialValues={
                    setGuestDeliveryAddressFormInitialValues
                  }
                  getMarketplaceDeliveryLocations={
                    getMarketplaceDeliveryLocations
                  }
                  setDeliveryLocation={setDeliveryLocation}
                  isMarketplaceDelivery
                />
              </GuestDeliveryForm>
            )}
          </>
        )}
      </MainDiv>
      <LocationsWrapper>
        {interDeliveryDetails &&
          interDeliveryDetails.deliveryBusiness &&
          interDeliveryDetails.deliveryBusiness.id && (
            <>
              <StoresWrapper>
                <Title1 style={{ fontWeight: '600', marginBottom: '24px' }}>
                  {'Current Store'}
                </Title1>
                <Stores>
                  <LocationCard
                    confirmMarketplaceDeliverySelection={
                      confirmMarketplaceDeliverySelection
                    }
                    marketplaceDeliveryLocation={interDeliveryDetails}
                    locations={locations}
                    deliveryLocation={deliveryLocation}
                    setDeliveryTimeFormIsVisible={setDeliveryTimeFormIsVisible}
                    isCurrentStore={true}
                    confirmDeliveryDetails={confirmDeliveryDetails}
                    getTimeIntervalsDate={getTimeIntervalsDate}
                    resetInterSelectedDateTime={resetInterSelectedDateTime}
                    interDeliveryDetails={interDeliveryDetails}
                    deliveryDetails={deliveryDetails}
                    updateInterDeliveryDetails={updateInterDeliveryDetails}
                    isRequesting={isRequesting}
                    setMarketplaceDeliverySelection={
                      setMarketplaceDeliverySelection
                    }
                    checkUnavailableProductForMarketplace={
                      checkUnavailableProductForMarketplace
                    }
                    validateCartForLocation={validateCartForLocation}
                    validateGlobalCart={validateGlobalCart}
                  />
                </Stores>
              </StoresWrapper>
            </>
          )}
        {marketplaceDeliveryLocations.length === 0 && !deliveryLocation && (
          <>
            <StoresWrapper>
              <Title1 style={{ fontWeight: '600', marginBottom: '24px' }}>
                Select Stores
              </Title1>
              <Body style={{ fontWeight: 'bold', marginBottom: '24px' }}>
                Add a delivery address to browse stores
              </Body>
            </StoresWrapper>
          </>
        )}
        {!isMarketplaceDeliveryLocationsRequest &&
          filteredMarketplaceDeliveryLocations.length !== 0 && (
            <>
              <StoresWrapper>
                <Title1 style={{ fontWeight: '600', marginBottom: '24px' }}>
                  {deliveryDetails ? 'Other Stores' : 'Select Store'}
                </Title1>
                {!isMarketplaceDeliveryLocationsRequest && (
                  <Stores>
                    {filteredMarketplaceDeliveryLocations &&
                      filteredMarketplaceDeliveryLocations.map(
                        (marketplaceDeliveryLocation) => (
                          <>
                            {marketplaceDeliveryLocation.deliveryBusiness &&
                              !isCurrentStore(marketplaceDeliveryLocation) &&
                              marketplaceDeliveryLocation.deliveryBusiness.accepted_order_types.includes(
                                interOrderType
                              ) && (
                                <LocationCard
                                  confirmMarketplaceDeliverySelection={
                                    confirmMarketplaceDeliverySelection
                                  }
                                  marketplaceDeliveryLocation={
                                    marketplaceDeliveryLocation
                                  }
                                  locations={locations}
                                  deliveryLocation={deliveryLocation}
                                  setDeliveryTimeFormIsVisible={
                                    setDeliveryTimeFormIsVisible
                                  }
                                  setDeliveryAddressesFormIsVisible={
                                    setDeliveryAddressesFormIsVisible
                                  }
                                  isUnavailableProductInCartRequest={
                                    isUnavailableProductInCartRequest
                                  }
                                  checkUnavailableProductForMarketplace={
                                    checkUnavailableProductForMarketplace
                                  }
                                  resetInterSelectedDateTime={
                                    resetInterSelectedDateTime
                                  }
                                  interOrderType={interOrderType}
                                  confirmDeliveryDetails={
                                    confirmDeliveryDetails
                                  }
                                  getTimeIntervalsDate={getTimeIntervalsDate}
                                  interDeliveryDetails={interDeliveryDetails}
                                  deliveryDetails={deliveryDetails}
                                  updateInterDeliveryDetails={
                                    updateInterDeliveryDetails
                                  }
                                  isRequesting={isRequesting}
                                  setMarketplaceDeliverySelection={
                                    setMarketplaceDeliverySelection
                                  }
                                  validateCartForLocation={
                                    validateCartForLocation
                                  }
                                  validateGlobalCart={validateGlobalCart}
                                />
                              )}
                          </>
                        )
                      )}
                  </Stores>
                )}
                {interOrderType && (
                  <Body style={{ color: '#737a87', marginTop: '25px' }}>
                    Couldn’t find what you’re looking for? Try Pickup instead.
                  </Body>
                )}
              </StoresWrapper>
            </>
          )}
      </LocationsWrapper>
    </>
  );
};

export default MarketplaceDelivery;
